import PropTypes from 'prop-types'

/**
 * @param {string} color - color of the icon.
 * @returns {React.ReactNode} - return an Educapoint Icon. 
 */
export function Educapoint(props) {

    const {color = "currentColor"} = props;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
            <path d="M15.0366 8.25C11.2949 8.25 8.25 11.2791 8.25 15.0015C8.25 15.0335 8.25293 15.0655 8.25585 15.0976L8.25879 15.1704C8.25879 15.1762 8.26172 15.3918 8.27636 15.5374C8.55449 19.0237 11.5233 21.75 15.0337 21.75C16.7172 21.75 18.3333 21.1268 19.5834 19.9967C20.0079 19.548 20.0226 18.852 19.6126 18.386C19.1881 17.9025 18.3831 17.8471 17.8971 18.2694L17.7828 18.3538C17.007 18.9859 16.032 19.3324 15.0337 19.3324C13.2858 19.3324 11.7136 18.2956 11.0255 16.6936L10.9436 16.4869H19.9201C20.9302 16.4869 21.75 15.6714 21.75 14.6665V14.0869C21.2991 10.7607 18.4123 8.25 15.0366 8.25ZM10.7825 14.0694L10.8323 13.8801C11.3447 11.9898 13.072 10.6675 15.0366 10.6675C17.0011 10.6675 18.7286 11.9898 19.238 13.8801L19.2877 14.0694H10.7825Z" fill={color} />
            <path fillRule="evenodd" clipRule="evenodd" d="M15 27C21.6274 27 27 21.6274 27 15C27 8.37258 21.6274 3 15 3C8.37258 3 3 8.37258 3 15C3 21.6274 8.37258 27 15 27ZM15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z" fill={color} />
        </svg>
    );
}

Educapoint.propTypes = {
    color: PropTypes.string
}